import { ListResponse } from '@/interfaces/list';
import { StructureNode } from '@/interfaces/structureNode';
import { StructureNodeResource, structureNodeResource } from '@/resources/structureNode.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł Struktury użytkowników
 *
 * @export
 * @class StructureNodeModule
 * @extends {EntityModule<StructureNode, StructureNodeResource>}
 */
export class StructureNodeModule extends EntityModule<StructureNode, StructureNodeResource> {
  constructor() {
    super(structureNodeResource);

    this.state = {
      ...this.state,

      externalMap: {}
    } as any;

    const superList = this.actions.list;

    this.mutations = {
      ...this.mutations,

      /**
       * Zapisuje strukturę do mapy
       *
       * @param {*} localState
       * @param {StructureNode} structure
       */
      saveByExternalUid(localState: any, structure: StructureNode): void {
        localState.externalMap[structure.externalUid as string] = structure;
        localState.externalMap[structure.copyUid as string] = structure;
      }
    };

    this.actions = {
      ...this.actions,

      /**
       * Pobiera listę węzłów struktury
       *
       * @param {*} context
       * @param {*} filters
       * @returns {Promise<ListResponse<StructureNode>>}
       */
      list(context: any, filters: any): Promise<ListResponse<StructureNode>> {
        return superList(context, { order: 'name', desc: false, ...filters }).then(result => {
          result.list = result.list.map((node: StructureNode) => {
            node.nameWithTypeDescription = `${node.name}  ${node.typeDescription ? `(${node.typeDescription})` : ''}`;
            return node;
          });
          return result;
        });
      },

      /**
       * Pobiera węzeł po zewnętrznym UID
       *
       * @param {*} context
       * @param {string} uid
       * @returns {Promise<StructureNode>}
       */
      getByExternalUid: (context: any, uid: string): Promise<StructureNode> =>
        this.resource.getByExternalUid(uid).then(structure => {
          if (structure) {
            context.commit('saveByExternalUid', structure);
          }
          return structure;
        }),

      /**
       * Aktualizuje samodzielność jednostki
       *
       * @param {*} context
       * @param {{ id: number; isSingle: boolean }} data
       * @returns {Promise<number>}
       */
      updateIsSingle: (context: any, data: { id: number; isSingle: boolean }): Promise<number> =>
        this.resource.updateIsSingle(data.id, data.isSingle)
    };
  }
}

export default new StructureNodeModule();
